import { FC } from 'react';
import { TTwoFaCommonProps } from '../../types';
import { AlertBox } from '../../../../../AlertBox/AlertBox';
import { TwoFaSectionTitle } from '../../../shared/TwoFaSectionTitle';
import { TwoFaSectionDescription } from '../../../shared/TwoFaSectionDescription';
import { CopyToClipboardButton } from '../../../../../CopyToClipboardButton/CopyToClipboardButton';
import { css } from '@bts-web/utils-style-engine';
import { ButtonBase } from '../../../../../ButtonBase/ButtonBase';
import { TwoFaSectionButtonsWrapper } from '../../../shared/TwoFaSectionButtonsWrapper';
import { TwoFaContentWrap } from '../../../shared/TwoFaContentWrap';
import { TwoFaScreenTranslations } from '../../../ResetTwoFaModal/utils/get2faTranslations';

export type RecoveryCodesPageProps = Pick<
  TTwoFaCommonProps,
  'onContinue' | 'recoveryCodes'
> & {
  translations: TwoFaScreenTranslations;
};

const RecoveryCodesPage: FC<RecoveryCodesPageProps> = ({
  onContinue,
  recoveryCodes,
  translations,
}) => {
  return (
    <>
      <TwoFaContentWrap>
        <TwoFaSectionTitle title={translations.recovery2faSubtitle} />
        <TwoFaSectionDescription textContent={translations.recovery2faBody} />
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: 'extra_small_2',
          })}
        >
          <h4
            className={css({
              textAlign: 'start',
              fontSize: 'label.medium_medium',
            })}
          >
            {translations.recovery2faInputfield}
          </h4>
          <textarea
            disabled
            value={recoveryCodes}
            className={css({
              width: '100%',
              height: '100px',
              resize: 'none',
              border: '1px solid',
              borderColor: 'neutrals.fill_tertiary',
              p: 'extra_small_3',
              minHeight: '106px',
              borderRadius: '8px',
            })}
          />
          <CopyToClipboardButton
            value={recoveryCodes}
            className={css({
              width: '100%',
              minHeight: '46px',
              borderColor: 'neutrals.fill_quaternary',
            })}
            ariaLabel="copy recovery codes"
            fullWidth
            visual="tertiary"
          >
            {translations.copy}
          </CopyToClipboardButton>
        </div>
        <AlertBox
          variant="warning"
          children={translations.recovery2faWarning}
        />
      </TwoFaContentWrap>
      <TwoFaSectionButtonsWrapper>
        <ButtonBase
          onClick={onContinue}
          visual="primary"
          size="medium"
          className={css({
            width: '100%',
            mt: 'extra_small_3',
          })}
        >
          {translations.continue}
        </ButtonBase>
      </TwoFaSectionButtonsWrapper>
    </>
  );
};

export { RecoveryCodesPage };
